import { MenuDivider, MenuHeader } from "@szhsin/react-menu";
import * as React from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { IconContext } from "react-icons";
import { FaHome } from "react-icons/fa";
import { FcHome } from "react-icons/fc";
import { FcQuestions } from "react-icons/fc";
import { FaQuestionCircle } from "react-icons/fa";
import { FcBiohazard } from "react-icons/fc";
import { BiBugAlt } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import { useSwipeable } from "react-swipeable";
import LoginAll from "./login-all";

const MySidebar = () => {

  const [toggled, setToggled] = React.useState(false);
  const [docSwipes, setDocSwipes] = React.useState<any>([]);
  const myDoc = document.querySelector("#root") as HTMLElement;

  const menuItemStyles = {
    root: { border: '0px', },
    button: {
      fontSize: '1.3em',
      fontVariant: 'all-small-caps',
      fontWeight: 'bolder',
      backgroundColor: '#111',
      '&:hover': {
        backgroundColor: '#222',
      },
    },
  }

  /*   const menuOptionStyles = {
      root: { border: '0px', },
      button: {
        fontSize: '1em',
        fontVariant: 'all-small-caps',
        backgroundColor: '#111',
        '&:hover': {
          backgroundColor: '#222',
        },
      },
    } */

  const { ref: documentRef } = useSwipeable({
    onSwiped: ({ dir, event }) => {
      setDocSwipes((s: any) => [...s, { dir, timeStamp: Math.floor(event.timeStamp) }]);
      //console.log(docSwipes);
      if (dir === 'Right') {
        setToggled(true);
      }
    },
    onSwiping: ({ event }) => event.stopPropagation()
  });

  React.useEffect(() => {
    documentRef(myDoc);
    // Clean up swipeable event listeners
    return () => documentRef({} as HTMLElement);
  });

  return (
    <div id="navBar">
      <Sidebar id="sidebar" width="200px" backgroundColor="#111" onBackdropClick={() => setToggled(false)} toggled={toggled} transitionDuration={700} breakPoint="all">
        <Menu closeOnClick menuItemStyles={menuItemStyles}>
          <MenuHeader>
            <div id="logo">
              <span id="version-display">
                <a href="About">v0.9.0</a>
              </span>
            </div>
          </MenuHeader>
          <IconContext.Provider value={{ color: "blue", size: "1.1em" }}>
            <MenuItem onClick={() => setToggled(false)} icon={<FcHome />} component={<Link to="/" />} rootStyles={menuItemStyles}>Home</MenuItem>
          </IconContext.Provider>
          <IconContext.Provider value={{ color: "white", size: "1.1em" }}>
            <MenuItem onClick={() => setToggled(false)} icon={<FcQuestions />} component={<Link to="About" />} rootStyles={menuItemStyles}>About</MenuItem>
          </IconContext.Provider>
          <MenuDivider />
          <MenuDivider />
          <IconContext.Provider value={{ color: "red", size: "1.1em" }}>
            <MenuItem onClick={() => setToggled(false)} icon={<FcBiohazard />} component={<Link to="Bugs" />} rootStyles={menuItemStyles}>Bugs</MenuItem>
          </IconContext.Provider>
          {/* <SubMenu icon={<MdOutlineSettings />} label="Options">
              <MenuItem onClick={() => setToggled(false)} component={<Link to="/Options" />} rootStyles={menuOptionStyles}>   Option 1</MenuItem>
              <MenuItem onClick={() => setToggled(false)} component={<Link to="/Options" />} rootStyles={menuOptionStyles}>   Option 2</MenuItem>
            </SubMenu> */}

        </Menu>
        <main>
        </main>
        <div id="navBarFooter">
          <LoginAll />
        </div>
      </Sidebar>
      <IconContext.Provider value={{ color: "white", className: "navButton" }}>
        <div id="sidebar-handle" onClick={() => setToggled(true)}>
          <GiHamburgerMenu />
        </div>
      </IconContext.Provider>
    </div>
  )
}

export default MySidebar;